import { render } from "./MethodsListSection.vue?vue&type=template&id=6d33193e&lang=pug"
import script from "./MethodsListSection.vue?vue&type=script&lang=js"
export * from "./MethodsListSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__